import React from 'react'
import Link from 'gatsby-link'
import styled, {ThemeProvider} from 'styled-components'

import Visibility from 'react-icons/lib/md/visibility'
import Map from 'react-icons/lib/md/map'
import Wifi from 'react-icons/lib/md/wifi'
import Arrow from 'react-icons/lib/md/keyboard-arrow-right'

import Dienstplan from '../components/dienstplan'
import Header from '../components/header'
import Feature from '../components/feature'
import Button from '../components/button'

import Image from '../static/live-map.svg'

const Faded = styled.span`
  opacity: 0.5;
  margin-left: 3px;
`

const DienstPlanPage = () => (
  <ThemeProvider
    theme={{
      color: '#ff5b3e'
    }}
  >
    <div>
      <Header
        title="Live Map"
        phrase="Fahrzeuge in Echtzeit verfolgen"
        image={{
          src: Image,
          height: 320 / 2
        }}
        bottom
      >
        Ist mein Fahrzeug bereits auf der Dienststelle? Sind alle Mannschaften
        bereits beschäftigt? Find es heraus mit der Live Map für iOS und
        Android.
      </Header>

      <a target="_blank" href="https://expo.io/@timo/144-map">
        <Button>
          Herunterladen <Faded>BETA</Faded>
        </Button>
      </a>
      <Feature title="Sei live dabei" icon={<Wifi />}>
        Du bist immer am Stand der Dinge – ohne neu zu laden. Alle Daten
        aktualisieren sich in Echtzeit.
      </Feature>
      <Feature title="Alles im Blick" icon={<Visibility />}>
        Neben der aktuellen Position sind auch Fahrzeugtyp und Verfügbarkeit auf
        einen Blick zu erkennen.
      </Feature>
      <Feature title="Optimiert für unterwegs" icon={<Map />}>
        Für Smartphone und Tablets entwickelt – schneller als jede Website.
      </Feature>
    </div>
  </ThemeProvider>
)

export default DienstPlanPage



// WEBPACK FOOTER //
// ./src/pages/live-map.js